import { useMemo } from 'react';

import { getPath } from '~/src/common/components/Navigation/utils';
import { isTruthy } from '~/src/common/utils/guards';
import { useNavigation } from '~/src/queries/api-ecom/generated/api-ecom';

import { getCrumb } from '../utils';

/**
 * Génère le fil d'ariane à partir de l'identifiant ou du slug d'une catégorie.
 *
 * Extrait et structure les données de navigation nécessaires pour construire un chemin
 * hiérarchique complet depuis la racine jusqu'à la catégorie spécifiée.
 */
export const useBreadcrumbFromId = (idOrSlug: string | null) => {
  const { data: nav } = useNavigation();

  const crumbs = useMemo(() => {
    // Récupération du path de la catégorie demandée
    if (nav == null || idOrSlug == null) return null;
    const path = getPath(nav, idOrSlug);
    if (path == null) return null;
    // Les éléments du chemin
    return [
      // Famille
      'family' in path && {
        ...getCrumb('family', path.family.item),
        link: path.family.item.link || null,
      },
      // Catégorie classique
      'category' in path && getCrumb('category', path.category.item),
      'subcategory' in path && getCrumb('category', path.subcategory.item),
      // Catégorie home
      'homecategory' in path && getCrumb('category', path.homecategory.item),
      'homesubcategory' in path && getCrumb('category', path.homesubcategory.item),
      // Catégorie recette
      'recipecategory' in path && getCrumb('category', path.recipecategory.item),
      'recipesubcategory' in path && getCrumb('category', path.recipesubcategory.item),
    ].filter(isTruthy);
  }, [nav, idOrSlug]);

  return crumbs;
};
